module.exports = __webpack_public_path__ + "h5/img/bs_22.db0a5698.jpeg";